import { createGlobalStyle } from 'styled-components';
import fontstyle from './fonts/PlayfairDisplaySC-Regular.ttf';
import futuraLight from './fonts/FuturaPT-Book.woff';

const FontStyles = createGlobalStyle`
    @font-face {
        font-family: 'Futura PT';
        src: url(${futuraLight}) format('woff');
        font-weight: 300;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'PlayfairDisplaySC-Regular';
        src: url(${fontstyle});
        format('truetype');
    }
`;

export default FontStyles;